module.exports = __webpack_public_path__ + "static/media/arrow-right-md-light.0f025b91.svg";